export default {"src":"/_next/static/media/PYPL.21fa9540.svg","height":18,"width":18};